// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clock-widget-panel[data-v-49ca95f1] {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-right: 0px;\n  padding-right: 10px;\n}\n.clock-widget-panel .sub-section-title[data-v-49ca95f1] {\n  padding-top: 4px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  width: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
